import React from "react";
import ReactDOM from "react-dom";

import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";

import App from "./App";
import configureStore, { history } from "./store";

const reduxStore = configureStore();

ReactDOM.render(
  <Provider store={reduxStore}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById("root")
);
